import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { SubmissionError } from 'redux-form';
import Icon from 'components/Icon';
import Dialog from 'components/modals/Dialog';
import DialogTitle from 'components/modals/DialogTitle';

import { updateSubscription, getSubscriptions } from '../../../../redux/actions/subscriptionActions';
import SubscriptionForm from './SubscriptionForm';

class SubscriptionUpdate extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    updateSubscription: PropTypes.func.isRequired,
    getSubscriptions: PropTypes.func.isRequired,
    accountId: PropTypes.string.isRequired,
    initialValues: PropTypes.shape({
      subscriptionId: PropTypes.number.isRequired,
      gateway_uid: PropTypes.string,
      subscription_type: PropTypes.number,
      products: PropTypes.array,
    }).isRequired,
  };

  static defaultProps = {
    className: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };

    this.toggle = this.toggle.bind(this);
  }

  async onSubmit(formData) {
    try {
      this.toggle();
      await this.props.updateSubscription(
        this.props.initialValues.subscriptionId,
        {
          gateway_uid: formData.gateway_uid,
          subscription_type: formData.subscription_type && formData.subscription_type.value,
          products: formData.products && formData.products.map(l => (l.value)),
        },
      );
      await this.props.getSubscriptions(this.props.accountId);
    } catch (error) {
      if (error.errors) {
        throw new SubmissionError(error.errors);
      }
    }
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  render() {
    return (
      <div className={this.props.className}>
        <Icon className="icon__edit" onClick={this.toggle} name="pencil" />
        <Dialog open={this.state.isOpen} onBackdropClick={this.toggle}>
          <DialogTitle disableTypography>Update subscription</DialogTitle>
          <SubscriptionForm
            initialValues={this.props.initialValues}
            toggleModal={this.toggle}
            onSubmit={data => this.onSubmit(data)}
          />
        </Dialog>
      </div>
    );
  }
}

export default compose(
  connect(
    null,
    { updateSubscription, getSubscriptions },
  ),
  withNamespaces('common'),
)(SubscriptionUpdate);
